document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger)
  
  function textWriter() {
    setTimeout(() => {
      const string = "eet David.";  
      const str = string.split("");
      const el = document.querySelector('.LP_Acquisition_top_detail_sides_innerright_maintitle_new .second-label');
      (function animate() {
        str.length > 0 ? el.innerHTML += str.shift() : clearTimeout(running); 
        var running = setTimeout(animate, 90);
      })();
    }, 3000)
  }

  if(window.innerWidth > 749) {
    let topBanner = gsap.timeline();
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_mainimage_new', { duration: 1, top: 0 })
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 0, opacity: 1 }, '+=0.5')
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 1, top: '-100px'})
    topBanner.to('.LP_Acquisition_top_detail_sides_mainright_new', { duration: 1, right: '0', translateX: '0' }, '+=2')
    topBanner.to('.LP_Acquisition_top_detail_sides_mainleft_new', { duration: 1, opacity: 1 }, '-=0.6')
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 0.5, top: '50px'})
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maininfos_new', { duration: 0, opacity: 1 })
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maininfos_new', { duration: 0.8, top: '-40px'})
    
    textWriter();
  } else {
    let topBanner = gsap.timeline();

    topBanner.to('.LP_Acquisition_top_detail_sides_mainright_new', { duration: 1, top: 0 })
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 0, opacity: 1 }, '+=0.5')
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 1, top: '120px'})
    topBanner.to('.LP_Acquisition_top_detail_sides_mainright_new', { duration: 1, top: 'auto' }, '+=2')
    topBanner.to('.LP_Acquisition_top_detail_sides_mainleft_new', { duration: 1, opacity: 1 })
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maintitle_new', { duration: 0.5, opacity: 0 }, '-=1.5')
    topBanner.to('.LP_Acquisition_top_detail_sides_innerright_maininfos_new', { duration: 0.5, opacity: 1 }, '-=1.2')
  
    textWriter();
  }

  let timelineTopInformationAnimation = gsap.timeline({
    scrollTrigger: {
      trigger: ".LP_Acquisition_image_text_new",
      start: "top center",
      end: '+=300',
      scrub: true,
    }
  });

  timelineTopInformationAnimation.to('.LP_Acquisition_image_text_sides_innerleft_boxs_2_new', { duration: 1, left: '14%'})
  timelineTopInformationAnimation.to('.LP_Acquisition_image_text_sides_innerleft_boxs_3_new', { duration: 1, left: '28%'})
  timelineTopInformationAnimation.to('.LP_Acquisition_image_text_sides_innerleft_boxs_4_new', { duration: 1, left: '42%'})
  timelineTopInformationAnimation.to('.LP_Acquisition_image_text_sides_innerleft_boxs_5_new', { duration: 1, left: '56%'})
  timelineTopInformationAnimation.to('.LP_Acquisition_image_text_sides_mainleft_maintags_new', { duration: 1, opacity: 1 })

 });